import { useEffect } from "react";
import { useAppUIStore } from "@/domains/app/stores/app-ui-store";
import { useNotifications } from "./use-notifications";

/**
 * Sync hook that keeps the app UI store in sync with the notification system
 * This ensures the sidebar and mobile tab badges show correct unread counts
 */
export function useNotificationSync() {
  const { setNotifications } = useAppUIStore();

  const { notifications, loading } = useNotifications({
    first: 50,
  });

  // Sync notifications to app UI store
  useEffect(() => {
    if (!loading && notifications.length >= 0) {
      // Transform to the format expected by app UI store
      const appNotifications = notifications.map((notification) => ({
        id: notification.id,
        title: notification.title,
        message: notification.message,
        type: notification.schemaKey || "info",
        priority: notification.priority || "NORMAL",
        isRead: notification.isRead,
        createdAt: notification.createdAt,
        actionUrl: notification.actionUrl,
        actionText: notification.actionText,
      }));

      setNotifications(appNotifications);
    }
  }, [notifications, loading, setNotifications]);

  return {
    syncing: loading,
  };
}
